import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";

export default function Layout() {
    const navigate = useNavigate();
    const [isASide, setIsAside] = useState(false);
    const [currentPage, setCurrentPage] = useState(sessionStorage.getItem("page") || "/");

    const asideHandler = () => setIsAside(isASide ? false : true);

    const NavigationBtn = (props) => {
        const clickHandler = () => {
            sessionStorage.setItem("page", props.path);
            setCurrentPage(props.path);
            setIsAside(false);
            navigate(props.path);
        };

        return (
            <button
                className="my-1 hover:bg-[var(--red)] hover:text-[var(--white)] capitalize p-2 text-left rounded-lg duration-200 w-3/4"
                onClick={clickHandler}
                style={
                    currentPage === props.path
                        ? {
                              background: "var(--red)",
                              color: "var(--white)",
                          }
                        : {}
                }
            >
                {props.children}
            </button>
        );
    };

    return (
        <main className="md:p-3.5">
            <button onClick={asideHandler} className="md:w-60 justify-center p-3 md:p-0 md:hidden">
                <img src="/logo/japanitip.png" className="w-[180px]" alt="japanitip" />
            </button>
            <section className="md:flex gap-5">
                <aside
                    className="md:w-60 capitalize p-3.5 md:relative fixed duration-200 bg-white w-full h-[100dvh] md:border-r pt-16 md:pt-3.5 md:rounded-xl md:shadow z-50"
                    style={{
                        left: window.innerWidth > 480 || isASide ? "0" : "-100%",
                        top: window.innerWidth > 480 ? "" : "0",
                    }}
                >
                    <button className="w-60 md:block p-0 hidden mb-10">
                        <img src="/logo/japanitip.png" className="w-[180px]" alt="japanitip" />
                    </button>
                    <button
                        className="absolute right-3.5 top-3.5 text-[var(--red)] py-1 px-2 md:hidden"
                        onClick={asideHandler}
                    >
                        <FontAwesomeIcon icon={faXmark} />
                    </button>
                    <NavigationBtn path="/">dashboard</NavigationBtn>
                    <NavigationBtn path="/price-list">price list</NavigationBtn>
                    <NavigationBtn path="/invoice">invoice</NavigationBtn>
                    <div
                        className="ml-2 duration-500 overflow-hidden w-full"
                        style={{
                            height: ["/invoice", "/invoice-create"].includes(currentPage) ? "max-content" : "0",
                            opacity: ["/invoice", "/invoice-create"].includes(currentPage) ? "1" : "0",
                        }}
                    >
                        <NavigationBtn path="/invoice-create">create invoice</NavigationBtn>
                    </div>
                    <NavigationBtn path="/schedule">schedule</NavigationBtn>
                    <NavigationBtn path="/accounting">accounting</NavigationBtn>
                </aside>

                <Outlet />
            </section>
        </main>
    );
}
